import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

// Dialog pentru redenumirea grupului (doar proprietarul).
export function RenameGroupDialog({ open, onOpenChange, value, onChange, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[340px] rounded-3xl">
        <DialogHeader>
          <DialogTitle className="font-heading">Editează numele</DialogTitle>
          <DialogDescription>Alege un nume nou pentru grup.</DialogDescription>
        </DialogHeader>
        <Input
          data-testid="rename-group-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSubmit()}
          className="h-12 rounded-xl"
          autoFocus
        />
        <DialogFooter>
          <Button
            data-testid="confirm-rename-btn"
            onClick={onSubmit}
            className="w-full rounded-xl bg-emerald-600 hover:bg-emerald-700 py-6 font-bold"
          >
            Salvează
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
